import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import AboutPage from "../pages/about/page";
import BibliotecaPage from "../pages/biblioteca/page";
import ArtistaPage from "../pages/biblioteca/artista/page";
import AlbumPage from "../pages/biblioteca/artista/album/page";
import CursosPage from "../pages/cursos/page";
import ContatoPage from "../pages/contato/page";
import LoginPage from "../pages/login/page";
import MinhaContaPage from "../pages/minha-conta/page";
import MeuPerfilPage from "../pages/meu-perfil/page";
import MinhaPlaylistPage from "../pages/minha-playlist/page";
import AppPage from "../pages/app/page";
import ComunidadePage from "../pages/comunidade/page";
import PerfilPublicoPage from "../pages/comunidade/perfil/page";
import ForumPage from "../pages/comunidade/forum/page";
import AdminPartiturasPage from "../pages/admin/partituras/page";
import CheckoutSucessoPage from "../pages/checkout/sucesso/page";
import AuthGuard from "../components/AuthGuard";
import AdminGuard from "../components/AdminGuard";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/sobre",
    element: <AboutPage />,
  },
  {
    path: "/biblioteca",
    element: <BibliotecaPage />,
  },
  {
    path: "/biblioteca/:artistaId",
    element: <ArtistaPage />,
  },
  {
    path: "/biblioteca/:artistaId/:albumId",
    element: <AlbumPage />,
  },
  {
    path: "/cursos",
    element: <CursosPage />,
  },
  {
    path: "/contato",
    element: <ContatoPage />,
  },
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    path: "/checkout/sucesso",
    element: <CheckoutSucessoPage />,
  },
  {
    path: "/app",
    element: <AppPage />,
  },
  {
    path: "/comunidade",
    element: <ComunidadePage />,
  },
  {
    path: "/comunidade/perfil/:userId",
    element: <PerfilPublicoPage />,
  },
  {
    path: "/comunidade/forum",
    element: <ForumPage />,
  },
  {
    path: "/minha-conta",
    element: (
      <AuthGuard>
        <MinhaContaPage />
      </AuthGuard>
    ),
  },
  {
    path: "/meu-perfil",
    element: (
      <AuthGuard>
        <MeuPerfilPage />
      </AuthGuard>
    ),
  },
  {
    path: "/minha-playlist",
    element: (
      <AuthGuard>
        <MinhaPlaylistPage />
      </AuthGuard>
    ),
  },
  {
    path: "/admin/partituras",
    element: (
      <AdminGuard>
        <AdminPartiturasPage />
      </AdminGuard>
    ),
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;